export default {
  getAccountSettings(state) {
    return state.accountSettings;
  },
  getEmailSenders(state) {
    return state.emailSenders;
  },
  getUsers(state) {
    return state.users;
  },
  getTokenData(state){
    return state.tokenData;
  },
  getFeaturePage(state){
    return state.featurePage
  }
};
